import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

$(function () {
    // For Display recommended ads
    let adId = $('#adIdForRecommendation').data('ad-id');
    $.ajax({
        type: 'POST',
        url: Routing.generate('recommended_ad'),
        data: {
            gravitoId: localStorage.getItem('gravitoOPUid'),
            adId: adId || '',
        },
        success(html) {
            $('#recommendedVehicles').html(html);
            // eslint-disable-next-line no-new
            new Swiper('.adRecommended > .swiperSlider', {
                modules: [Navigation],
                lazy: true,
                lazyPreloadPrevNext: 1,
                slidesPerView: 2.5,
                slidesPerGroup: 2,
                spaceBetween: 3,
                speed: 700,
                breakpoints: {
                    1024: {
                        slidesPerView: 6,
                        slidesPerGroup: 6,
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    addIcons: false,
                },
            });
            if (adId) {
                if ($('.details-page-view-history__tab-active').attr('data-id') === 'vifRecommendedAd') {
                    commonUtils.dataLayer.productListImpressionDataLayerEvent(
                        $('#recommendedAdDatalayerJson').data('datalayer-json'),
                        'VIF',
                        'Sisältösuosittelut'
                    );
                }
            } else {
                commonUtils.dataLayer.productListImpressionDataLayerEvent(
                    $('#recommendedAdDatalayerJson').data('datalayer-json'),
                    'Etusivu',
                    'Sisältösuosittelut'
                );
            }
        },
    });

    // Send datalayer event on click recommended ad tab in VIF
    $('body').on('click', '#recommendedAdTab', function () {
        commonUtils.dataLayer.productListImpressionDataLayerEvent(
            $('#recommendedAdDatalayerJson').data('datalayer-json'),
            'VIF',
            'Sisältösuosittelut'
        );
    });
});
